import React, { createContext, useState, useEffect, useContext } from 'react'
import melodies15 from "../helpers/melodies15"
import melodies255 from "../helpers/melodies255"
import { StateContext } from "../context/StateContext"
import { fetchMelodiesByDevice } from "../helpers/fetchMelodies"

export const MelodiesContext = createContext()

/**
 * Контекст мелодий (звонов).
 */
export const MelodiesContextProvider = ({ children }) => {
    const STATE = useContext(StateContext)

    /**
     * Мелодии (звоны).
     */
    const [melodies, setMelodies] = useState([])

    /**
     * Сопоставит названия мелодий с их номерами.
     */
    const fetchingTitles = async () => {
        const titles = await fetchMelodiesByDevice(STATE.lastData.deviceId)

        let melodies = []
        let defaultMelodies = STATE.lastData.maxMelodies !== undefined ? melodies255 : melodies15;

        defaultMelodies
            .filter(
                (item) => item.id > 0 && item.id <= (STATE.lastData.maxMelodies ?? 15)
            )
            .forEach((item) => {
                if (item.id in titles) {
                    melodies.push({ ...item, title: titles[item.id] })
                } else {
                    melodies.push({ ...item })
                }
            })

        setMelodies(melodies)
    }

    /**
     * Загрузит названия мелодий.
     */
    useEffect(() => {
        if (!!STATE.lastData) {
            fetchingTitles()
        }
    }, [STATE.lastData])

    /**
     * Вернет название звона по его id.
     *
     * @param {int}   id       Идентификатор звона.
     * @param {Array} haystack Список мелодий для поиска.
     * 
     * @returns {null|string}
     */
    const getTitle = (id, haystack = null) => {
        let result = 'НЕИЗВЕСТНЫЙ ЗВОН'

        if (haystack === null) {
            haystack = [...melodies]
        }

        if (haystack.length === 0) {
            result = 'ЗВОНЫ ОТСУТСТВУЮТ'
        } else {
            haystack.forEach((item) => {
                if (parseInt(item.id, 10) === parseInt(id, 16)) {
                    result = item.title;
                    return
                }
            })
        }

        return result
    }

    return (
        <MelodiesContext.Provider
            value={{
                melodies,
                getTitle
            }}
        >
            {children}
        </MelodiesContext.Provider>
    );
}